import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-queue-landing-icon',
  templateUrl: './queue-landing-icon.component.html',
  styleUrls: ['./queue-landing-icon.component.scss']
})
export class QueueLandingIconComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
